export default __webpack_public_path__ + "static/media/loaf-top.ee5fdd5d.png";